import React, { useContext } from 'react';

import GenericFormModal from './shared/GenericFormModal';
import EditSelect from './shared/field_inputs/select/EditSelect';

import { DataContext } from '../../stores/crm-store';

const LostModal = ({ handleUpdate, label, description, initialValues }) => {
    const {
        store: { lostReasonOptions },
    } = useContext(DataContext);

    const formComponents = [
        {
            propName: 'lostReason',
            label: 'Förlustorsak',
            validate: (v) => (!v ? 'Måste anges' : ''),
            component: <EditSelect options={lostReasonOptions} />,
        },
    ];

    return (
        <GenericFormModal
            label={label}
            description={description}
            formComponents={formComponents}
            defaultFormValues={initialValues}
            handleAdd={handleUpdate}
            buttonType='btn-danger'
        />
    );
};

LostModal.defaultProps = {
    initialValues: {},
};

export default LostModal;
